var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedtick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 189,
    viewBox: "0 0 195 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.2568 188.526C151.069 188.655 194.802 146.741 194.935 94.9069C195.069 43.0729 151.555 0.948556 97.7432 0.819253C43.9311 0.689947 0.198463 42.6047 0.0646434 94.4383C-0.070153 146.272 43.4447 188.397 97.2568 188.526Z",
    fill: "#F08203"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3046 170.244C140.634 170.348 175.847 136.598 175.955 94.8617C176.063 53.1251 141.026 19.2066 97.6954 19.1026C54.3661 18.9984 19.153 52.7481 19.0446 94.4844C18.9371 136.221 53.9744 170.139 97.3046 170.244Z",
    fill: "#F08203"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.455 132.395L56.894 98.0861L73.0042 86.0788L86.0531 102.323L130.394 57.4628L145.148 70.9925L84.455 132.395Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedtick);
export default __webpack_public_path__ + "static/media/Verifiedtick.2c245422bde6cb1378f4b4c5389aff26.svg";
export { ForwardRef as ReactComponent };